import { AuctionLightDTO, defaultAuctionLightDTO } from 'models'
import React from 'react'

type AuctionLightContextType = {
  auctionLight: AuctionLightDTO
  setAuctionLight: React.Dispatch<React.SetStateAction<AuctionLightDTO>>
}

const AuctionLightContext = React.createContext<AuctionLightContextType>({
  auctionLight: defaultAuctionLightDTO,
  setAuctionLight: () => {},
})

const AuctionLightProvider = ({ children }: React.PropsWithChildren<unknown>) => {
  const [auctionLight, setAuctionLight] = React.useState<AuctionLightDTO>(defaultAuctionLightDTO)

  const providerValue = React.useMemo(
    () => ({
      auctionLight,
      setAuctionLight,
    }),
    [auctionLight],
  )

  return (
    <AuctionLightContext.Provider value={providerValue}>{children}</AuctionLightContext.Provider>
  )
}

const useAuctionLight = () => React.useContext(AuctionLightContext)

export { AuctionLightContext, AuctionLightProvider, useAuctionLight }
